export default [
  'CbpResourceRepositoryFactory',
  function (CbpResourceRepositoryFactory) {
    return new CbpResourceRepositoryFactory('/sid/agent/sid-requests/{requestId}/sid-response-forwards');
  },
];
